import type { UrlEntry, UrlRegion } from '@/types';

export const isIndexable = false;

export const urls: Record<'apply', Record<UrlRegion, UrlEntry>> = {
  apply: {
    de: 'bewerben',
    'de-en': 'apply',
    es: 'solicitar-plaza',
    'es-en': 'apply',
    fr: 'inscription',
    'fr-en': 'apply',
    gb: 'apply',
    nl: 'aanmelden',
    'nl-en': 'apply',
    pt: 'inscrever',
    'pt-en': 'apply',
    us: 'apply',
    ww: 'apply',
  },
};
